import React from "react";
import { FaBed, FaBus } from "react-icons/fa";
import { GiForkKnifeSpoon } from "react-icons/gi";
import { BsPersonFill } from "react-icons/bs";
import { createSearchParams, useNavigate } from "react-router-dom";
import { IPackage } from "../../types/global";

const GlobalPkgCard = ({ data }: { data: IPackage }) => {
  let navigate = useNavigate();
  const handleRoute = (searchParam: {} | null) => {
    // setActivePage(`${route["nav-item"]}`)
    if (searchParam) {
      navigate({
        pathname: "/package-details",
        search: createSearchParams(searchParam).toString(),
      });
    } else {
      navigate({
        pathname: "/package-details",
      });
    }
  };

  return (
    <div className="shadow-lg rounded-bl-2xl rounded-br-2xl relative group">
      <div className="h-80 w-full overflow-hidden">
        <a href={`/package-details?pkg=${data.id}`}>
          <img
            src={`${process.env.REACT_APP_API}/uploads/images/${data.package_img}`}
            alt=""
            srcSet=""
            className="h-full w-full object-cover cursor-pointer transition-transform duration-300 group-hover:scale-105 group-hover:transition-transform group-hover:duration-300"
            // onClick={() => handleRoute({ pkg: data.id })}
          />
        </a>
      </div>
      {/* TODO: from backend feature  */}
      {/* spcial tag
            {data.tag && <div className=" px-4 py-1.5 text-white w-fit font-medium absolute top-0 ml-4 rounded-bl-xl rounded-br-xl" style={{ backgroundColor: `${data.tag.color}` }}>
                <p className="capitalize text-justify">{data.tag.title}</p>
            </div>} */}
      {/* contents section  */}
      <div className="p-4">
        <div className="bg-primary-base px-2 py-1 text-white w-fit font-medium absolute -mt-8">
          <p>
            {data.day}D | {data.night}N
          </p>
        </div>
        <h1
          className="text-xl font-semibold leading-normal line-clamp-2 mt-5 mb-2 capitalize cursor-pointer"
          onClick={() => handleRoute({ pkg: data.id })}
        >
          {data.translation[0].package_title}
        </h1>
        <div>
          <h2 className="font-medium">
            Starting{" "}
            <span className="text-primary-base">${data.starting_price}</span>
          </h2>
        </div>

        {/* <div className="flex item-top justify-between mt-8 mb-4 text-sm space-x-2 ">
          {data?.pkgAmenities.map((item, i) => (
            <div className="text-center" key={item.id}>
              <img
                src={`${process.env.REACT_APP_API}/uploads/images/${item.amenity.amenity_icon}`}
                alt=""
                className="h-6 w-6 object-cover mx-auto"
              />
              <p className="lg:text-[13px] mt-2">{item.amenity.amenity}</p>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default GlobalPkgCard;
